module.exports = __webpack_public_path__ + "img/icon4.953f5bf5.svg";